import { createSlice } from '@reduxjs/toolkit'

export const SUGGESTED_PROMPTS: any = [
  {
    label: "Create a board",
    prompt: "Create a board named: Demo Board",
  },
  {
    label: "Create a task",
    prompt: "Create a task in board [Board Name] named: ",
  },
  {
    label: "Create a page",
    prompt: "Create a page in board [Board Name] with title: ",
  },
  {
    label: "Create a column",
    prompt: "Create a column in board [Board Name] named: ",
  },
  {
    label: "Add Task Comment",
    prompt: "Add a comment to task [Task Name]: ",
  },
  {
    label: "Update Board Status",
    prompt: "Update status of board [Board Name] to: ",
  },
  {
    label: "Update Task Status",
    prompt: "Update status of task no. : [boardnumber-1] ",
  },
  {
    label: "Update Page Status",
    prompt: "Update page [Page Name] status to: ",
  },
];

const initialState: any = {
  currentChat: null,
  messages: [],
}

export const AiSlice = createSlice({
  name: 'AiSlice',
  initialState,
  reducers: {
    setCurrentChat: (state, action) => {
      state.currentChat = action.payload
    },
    setMessages: (state, action) => {
      state.messages = action.payload
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload)
    },
    clearMessages: (state) => {
      state.messages = []
    },
    resetAiState: (state) => {
      state.currentChat = null
      state.messages = []
    },
  },
})

export const { setCurrentChat, setMessages, addMessage, clearMessages, resetAiState } = AiSlice.actions

export default AiSlice.reducer
